import {
  UPDATE_CITY_BY_ID_GRAPH_QL,
  UPDATE_CITY_BY_ID_GRAPH_QL_SUCCESS,
  UPDATE_CITY_BY_ID_GRAPH_QL_FAILURE,
} from './const'
import createMiddleware from 'Reducers/createMiddleware'
import { updateCity } from 'Module/graphQL'

export const updateCityMiddleware = createMiddleware({
  actions: [
    UPDATE_CITY_BY_ID_GRAPH_QL,
    UPDATE_CITY_BY_ID_GRAPH_QL_SUCCESS,
    UPDATE_CITY_BY_ID_GRAPH_QL_FAILURE,
  ],
  fetchMethod: (authToken, { cityId, payload }) => {
    const { values, callbacks } = payload

    const res = updateCity(authToken, cityId, values)

    if (callbacks && typeof callbacks.onSuccess === 'function') {
      callbacks.onSuccess()
    }

    return res
  },
  isOptimistic: true,
})



// WEBPACK FOOTER //
// ./src/Reducers/City/middleware.js